import React from 'react'
import { useNavigate,useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CHeader,CHeaderBrand,CHeaderNav,CHeaderToggler,CHeaderDivider,
	CFooter,
	CRow,
	CCol,
	CContainer,
	CForm,CFormInput,CFormTextarea,CInputGroup,CInputGroupText,CButton,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CSpinner,
	CBadge,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import {
	MyHeaderProfile,
	MyButton,
	MyDialogform,
	MyDialoglookup,
	MyDialogperawat,
	MyDialogodontogram,
} from '../../components/index'
import { Konfirm } from '../../helpers/onConfirm'
import { UFunc } from '../../helpers/functions'
import useSatusehat from '../../helpers/useSatusehat'

const pjson 		= require('../../../package.json')
const Rekammedisform = (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif 
	} = props;
	const { tabel_id } 				= useParams(); 

	//--DOM--/
	const uNavigate 				= useNavigate();
	const uDispatch 				= useDispatch();
	const { loadToken } 			= useSatusehat(props);
	//--END DOM--/

	const uRekammedisID				= parseInt(tabel_id)||0;
	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uUrlbefore 				= useSelector(state => state.gUrlbefore);

	const [uEfekview,setEfekview] 	= React.useState(false);
	const [uLoadingview,setLoadingview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 10) : (uSettingObj.jml_laporan || 100);
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uIsHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 

	const uTokensatusehatObj			= JSON.parse(localStorage.getItem("tokensatusehat") || "{}");
	const [uDatamainObj,setDatamainObj]		= React.useState({})
	const [uDataanamnaseArr,setDataanamnaseArr]	= React.useState([]);
	const [uDatadiagnosaArr,setDatadiagnosaArr]	= React.useState([]);
	const [uISExecutesimpanfield,setExecutesimpanfield]	= React.useState(false);

	//--DLG_FORM--/
	const [uDlgformObj,setDlgformObj]		= React.useState({})
	const [uISDlgformshow,setDlgformshow]	= React.useState(false)
	//--END DLG_FORM--/

	//---DLG_LOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]	= React.useState(false)
	const [uDlglookupdataObj,setDlglookupdataObj]	= React.useState({})
	//---END DLG_LOOKUP--/

	//---DLG_PERAWAT--/
	const [uISDlgperawatshow,setDlgperawatshow]		= React.useState(false)
	const [uDlgperawatdataObj,setDlgperawatdataObj]	= React.useState({})
	const uPerawatselectingArr 				= JSON.parse(useSelector(state => state.perawat_selecting_str) || "[]");
	//---END DLG_PERAWAT--/

	//---DLG_ODONTOGRAM--/
	const [uISDlgodontogramshow,setDlgodontogramshow]	= React.useState(false)
	const [uDlgodontogramdataObj,setDlgodontogramdataObj]= React.useState({})
	const uOdontogramprocessingArr 			= JSON.parse(useSelector(state => state.gigi_processing_str) || "[]");
	//---END DLG_ODONTOGRAM--/

	//--DOM--/
	const uWindowwidth		= window.outerWidth;//->TINDAKAN_TROBEL_HARUS_OUTERWIDTH
	const uISTabletview 	= (uWindowwidth > 425 && uWindowwidth <= 768);
	const uISCellphoneview 	= (uWindowwidth <= 425);
	//--END DOM--/

	//---HANDEL--/
	const hdlKDownDocument = (_EV) => {}
	const hdlKlikBack = () => { uNavigate(-1); }
	const hdlKlikReset = async() => {
		if(uHtml500msg) {
			apiLoaddata(); return;
		}

		if(await Konfirm("<b>Anda Akan Merefresh Data Rekammedis</b>.."+
			"<p class='fst-italic'>Apakah Anda Yakin ?</p>"+
			"")) apiLoaddata();
	}
	const hdlKlikPerawat = () => {
		//console.log("(Rekammedisform - hdlKlikPerawat) perawat_arr",uDatamainObj.perawat_arr)

		setDatamainObj({...uDatamainObj,
			edit_obj: {
				nama_field: "perawat_arr",
				value: JSON.stringify(uDatamainObj.perawat_arr || []),
				value_lama: JSON.stringify(uDatamainObj.perawat_arr || []),
			}
		})

		setDlgperawatdataObj({
			selected_arr: uDatamainObj.perawat_arr || [],
		})
		setDlgperawatshow(true);
	}
	const hdlKlikDlgperawatsimpan = () => {
		//alert(JSON.stringify(uPerawatselectingArr)); return;
		if(uPerawatselectingArr.length <= 0) {
			setDlgperawatshow(false);
			return;
		}

		const vPerawatNOchangeArr = (uDatamainObj.perawat_arr||[]).
			filter(vItems=> {
				const vArridx = UFunc.getObjectIndeks(uPerawatselectingArr,vItems.id_perawat);
				return vArridx < 0 //|| (vArridx >= 0 && (uPerawatselectingArr[vArridx].status_hapus||"TIDAK") !== "YA")
			}); 

		const vPerawatupdateArr	= uPerawatselectingArr.
			filter(vItems=>(parseInt(vItems.id_item)||0) > 0).//-->ID_ITEM = trekammedis_perawat.id
			map(vItems => {
				return {...vItems,
					id_item: undefined,
					id: vItems.id_item,
					id_perawat: vItems.id,
				}
		});

		const vPerawatnewArr	= uPerawatselectingArr.
			filter(vItems=>(parseInt(vItems.id_item)||0) <= 0 && (vItems.status_hapus||"TIDAK")!=="YA").
			map(vItems => {
				return {...vItems,
					id_item: undefined,
					id: vItems.id_item,
					id_perawat: vItems.id,
				}
		});

		//console.log("(Rekammedisform - hdlKlikDlgperawatsimpan) vPerawatnewArr",vPerawatnewArr);
		/*setDatamainObj({...uDatamainObj,
			perawat_arr: [...vPerawatNOchangeArr,...vPerawatupdateArr,...vPerawatnewArr]
		})
		setDlgperawatshow(false); return;
		//-*/

		const vValuenewArr	= [...vPerawatNOchangeArr,...vPerawatupdateArr,...vPerawatnewArr];
		setDatamainObj({...uDatamainObj,
			edit_obj: {...(uDatamainObj.edit_obj||{}),
				value: JSON.stringify(vValuenewArr),
			}
		})
		setDlgperawatshow(false);
		setExecutesimpanfield(true);
	}
	const hdlKlikAnamnase = () => {
		setDatamainObj({...uDatamainObj,
			edit_obj: {
				nama_field: "anamnase_id",
				jenis_field: "lookup",
				value: uDatamainObj.anamnase_id,
				value_lama: uDatamainObj.anamnase_id,
			}
		})
		
		setDlglookupdataObj({
			dlg_header: "Lookup: ANAMNASE",
			data_arr: uDataanamnaseArr.map(vItems=>{return {id:vItems.id,caption:vItems.nama_anamnase} }),
		});
		setDlglookupshow(true);
	}
	const hdlKlikDiagnosa = (_IDXKEY) => {
		_IDXKEY	= parseInt(_IDXKEY);

		//console.log("(Rekammedisform - hdlKlikDiagnosa) (uDatamainObj.items_arr||[])[_IDXKEY] ",(uDatamainObj.items_arr||[])[_IDXKEY]);
		setDatamainObj({...uDatamainObj,
			edit_obj: {
				nama_field: "items",
				jenis_field: "lookup",
				items_idx: _IDXKEY,
				items_var: "diagnosa_id",
				items_id: parseInt(((uDatamainObj.items_arr||[])[_IDXKEY]||{}).id_item),
				value: parseInt(((uDatamainObj.items_arr||[])[_IDXKEY]||{}).diagnosa_id),
				value_lama: parseInt(((uDatamainObj.items_arr||[])[_IDXKEY]||{}).diagnosa_id),
			}
		})

		setDlglookupdataObj({
			dlg_header: "Lookup: DIAGNOSA ICD-10",
			data_arr: uDatadiagnosaArr.map(vItems=>{return {id:vItems.id,caption:vItems.nama_diagnosa} }),
		});
		setDlglookupshow(true);
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM	= parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx = UFunc.getObjectIndeks((uDlglookupdataObj.data_arr||[]),_IDITEM);
		setDatamainObj({...uDatamainObj,
			edit_obj: {...(uDatamainObj.edit_obj||{}),value: _IDITEM,}
		});

		setExecutesimpanfield(true);
	}
	const hdlKlikPilihgigi = (_IDXKEY) => {
		_IDXKEY				= parseInt(_IDXKEY);
		const vOdontogramArr= ((uDatamainObj.items_arr||[])[_IDXKEY] || {}).odontogram_arr || [];

		setDatamainObj({...uDatamainObj,
			edit_obj: {
				nama_field: "items",
				items_var: "ket_gigi",
				items_idx: _IDXKEY,
				items_id: parseInt(((uDatamainObj.items_arr||[])[_IDXKEY]||{}).id_item),
				value: JSON.stringify(vOdontogramArr),
				value_lama: JSON.stringify(vOdontogramArr),
			}
		})
		setDlgodontogramdataObj({
			selected_arr: vOdontogramArr,
		});
		setDlgodontogramshow(true);
	}
	const hdlKlikDlgodontogramsimpan = () => {
		//--VALIDASI_JIKA_SAMA--/
		//--END VALIDASI_JIKA_SAMA--/

		/*//--TESTING--/
		const vEditobj	= uDatamainObj.edit_obj || {};
		const vKetgigi 	= uOdontogramprocessingArr.map(vItems=>{
			return "No-"+vItems.nomor_gigi;
		}).join(", ");
		(uDatamainObj.items_arr||[])[vEditobj.items_idx] = {
			...((uDatamainObj.items_arr||[])[vEditobj.items_idx] ||{}),
			ket_gigi: vKetgigi,
			odontogram_arr: uOdontogramprocessingArr || [],

		}
		setDlgodontogramshow(false); return;
		//--END TESTING--*/

		setDatamainObj({...uDatamainObj,
			edit_obj: {...(uDatamainObj.edit_obj||{}),
				value: JSON.stringify(uOdontogramprocessingArr || []),
			}
		})

		setDlgodontogramshow(false);
		setExecutesimpanfield(true);
	}
	const hdlKlikEditfield = (_EDITVARS,_ADDOBJ) => {
		_EDITVARS 	= _EDITVARS || "";
		_ADDOBJ		= _ADDOBJ || {};

		if(_EDITVARS.toUpperCase() !== ("items").toUpperCase()) {
			setDatamainObj({...uDatamainObj,
				edit_obj: {
					nama_field: _EDITVARS,
					value: uDatamainObj[_EDITVARS],
					value_lama: uDatamainObj[_EDITVARS],
				}
			})

			let vTimeout	= setTimeout(()=>{
				clearTimeout(vTimeout);

				const vElfocus = document.getElementById("inpeditfield");
				if(!isMobile) vElfocus && vElfocus.focus();
			},350);
			return;
		}

		const vArridx	= _ADDOBJ.idxkey;// ? parseInt(_ADDOBJ.idxkey) : -1;
		setDatamainObj({...uDatamainObj,
			edit_obj: {
				nama_field: _EDITVARS,
				items_var: _ADDOBJ.nama_vars,
				items_idx: vArridx,
				items_id: parseInt(((uDatamainObj.items_arr||[])[vArridx]||{}).id_item),
				value: ((uDatamainObj.items_arr||[])[vArridx] || {})[_ADDOBJ.nama_vars||""],
				value_lama: ((uDatamainObj.items_arr||[])[vArridx] || {})[_ADDOBJ.nama_vars||""],
			}
		})

		let vTimeout	= setTimeout(()=>{
			clearTimeout(vTimeout);

			const vElfocus = document.getElementById("inpeditfield");
			if(!isMobile) vElfocus && vElfocus.focus();
		},350);
	}
	const hdlKlikClearfield = async(_EDITVARS,_ADDOBJ) => {
		_EDITVARS 	= _EDITVARS || "";
		_ADDOBJ		= _ADDOBJ || {};

		let vCaptions	= ("Anamnase").toUpperCase();
		if(_EDITVARS === "items") {
			if(_ADDOBJ.nama_vars === "ket_gigi")
				vCaptions	= ("Nomor Gigi").toUpperCase();
			else if(_ADDOBJ.nama_vars === "diagnosa_id")
				vCaptions	= ("Diagnosa ICD-10").toUpperCase();
		}

		const vNextfunction = () => {
			if(_EDITVARS === "anamnase_id") {
				setDatamainObj({...uDatamainObj,
					edit_obj: {
						nama_field: _EDITVARS,
						value: 0,
						value_lama: uDatamainObj[_EDITVARS],
						jenis_field: "lookup",
					}
				})
			} else if(_EDITVARS === "items") {
				const vArridx	= _ADDOBJ.idxkey;// ? parseInt(_ADDOBJ.idxkey) : -1;
				setDatamainObj({...uDatamainObj,
					edit_obj: {
						nama_field: _EDITVARS,
						items_var: _ADDOBJ.nama_vars,
						items_idx: vArridx,
						jenis_field: "lookup",
						items_id: parseInt(((uDatamainObj.items_arr||[])[vArridx]||{}).id_item),
						value: "",
						value_lama: ((uDatamainObj.items_arr||[])[vArridx] || {})[_ADDOBJ.nama_vars||""],
					}
				})
			}
			setExecutesimpanfield(true);
		}

		if(await Konfirm("<b>Anda Akan Mereset Data "+vCaptions+"</b>.."+
			"<p class='fst-italic'>Apakah Anda Yakin?</p>"+
			"")) vNextfunction();
	}
	const hdlKDownfieldedit = (_EV) => {
		if(_EV.keyCode !== 27 && _EV.keyCode !== 13) return;

		if (_EV.target.nodeName === "TEXTAREA") {
			if(isMobile) return;
			if(_EV.shiftKey) return;
		}

		if(_EV.keyCode === 27) {
			_EV.stopPropagation();
			_EV.preventDefault();
			setDatamainObj({...uDatamainObj,edit_obj:undefined});
			return;
		}

		if(_EV.keyCode === 13) {
			_EV.stopPropagation();
			_EV.preventDefault();

			hdlKlikSimpanfield();
			return;
		}
	}
	const hdlKlikSimpanfield = () => {
		//--CEK_VALIDASI--/
		//console.log("(Rekammedisform - hdlKlikSimpanfield) edit_obj ",uDatamainObj.edit_obj);
		if(((uDatamainObj.edit_obj||{}).value||"").toString().trim() === ((uDatamainObj.edit_obj||{}).value_lama||"").toString().trim()) {
			setDatamainObj({...uDatamainObj,edit_obj:undefined});
			setDlglookupshow(false);
			return;
		}
		//--END CEK_VALIDASI--/

		apiProsessimpanfield();
	}
	const hdlKlikKirimsatusehat = async() => {
		if((uDatamainObj.init_satusehat||"BELUM")==="SUDAH") {
			showToast(
				"<p class='fw-bolder'>Integrasi Satusehat Sudah Pernah Dilakukan</p>"+
				"<p>Mohon Dicek Kembali, Karena Proses Hanya Dapat Dilakukan SATU kali!</p>"+
				"")
			return;
		}

		if((parseInt(uDatamainObj.id_progress)||0) <= 0) {
			showToast(
				"<p class='fw-bolder'>Data Kunjungan Tidak Valid..</p>"+
				"<p>Kemungkinan Rekam Medis Merupakan Data Lama, Sehingga Data Progress Kunjungan Belum Tercatat!</p>"+
				"")
			return;
		}

		if(await Konfirm("<p><b>Kirim Data ke Server SATUSEHAT</b>..</p>"+
			"<small class='fst-italic'>"+
			"<p>Data Pemeriksaan Pasien Akan Dikirim ke SATUSEHAT. Proses Ini Hanya Dapat Dilakukan SEKALI.</p>"+
			"<p>Proses Tidak Dapat DIULANGI ataupun DIBATALKAN.</p>"+
			"</small>"+
			"Apakah Anda Yakin ?"+
			"")) apiKirimsatusehat();
	}
	const hdlKlikDlgformsimpan = () => {}
	const hdlKlikSimpanmain = () => {}
	//---END HANDEL--/

	//---INIT_PROCESS--/
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentHeadernav = () => {
		if(uHtml500msg) return "";

		return (
		<>			
			<CLink onClick={()=>hdlKlikReset()} className="classcursorpointer classikon classikonreset me-1"/>
			
			{(!uLoadingview && !uHtml500msg) && (
			<>
				{(uDatamainObj.status_kasir||"BELUM") === "SUDAH" && (
					<>
					{(uDatamainObj.init_satusehat||"BELUM") === "SUDAH" ? (
					<CBadge color="light" className="border text-success">
						<CIcon icon="cilCheckAlt" className="align-middle me-1" height={23}/>
						<CImage src={pjson.homepage+"api\/images\/icon_satusehat.png"} className="align-middle" height={20}/>
					</CBadge>
					) : (
					<CButton size="sm" color="light"
						className="border text-success"
						onClick={()=>hdlKlikKirimsatusehat()}
						id="btnkirimss">
						<CIcon icon="cilExternalLink" className="align-middle" height={16}/>
						<small className="fw-bold mx-2">Kirim Satusehat</small>
						<CImage src={pjson.homepage+"api\/images\/icon_satusehat.png"} className="align-middle" height={20}/>
					</CButton>
					)}
					</>
				)}
			</>
			)}
		</>
		)//>
	}
	const contentKunjungan = () => {
		if(uHtml500msg) return "";

		return(
		<CCard className="classbgcard h-100">
			<CCardHeader className="py-0 pt-1 classfontsmaller">
				<small>Data Kunjungan</small>
			</CCardHeader>

			<CCardBody>
			<small>
				<div className="d-flex justify-content-between my-2">
					<span className="px-1">Tgl Periksa</span>
					<b className="px-1">{UFunc.TglAngka(uDatamainObj.tgl_periksa)}</b>
				</div>

				<div className="d-flex justify-content-between my-2">
					<span className="px-1">Dokter</span>
					<b className="px-1 text-end">{(uDatamainObj.dokter_caption || "DRG.Undf Dokter")}</b>
				</div>
			</small>
			</CCardBody>
		</CCard>
		)//>
	}
	const contentPerawat = () => {
		if(uHtml500msg) return "";

		return(
		<CCard className="classbgcard h-100">
			<CCardHeader className="py-0 pt-1 classfontsmaller">
				<small>Data Perawat</small>
			</CCardHeader>
			
			<CCardBody className="text-center">
			{(((uDatamainObj.edit_obj||{}).is_processing||false)===true
				&& ((uDatamainObj.edit_obj||{}).nama_field||"")==="perawat_arr"
			) ? (
				<CSpinner color="warning"/>
			) : (
			<>
				{(uDatamainObj.perawat_arr || []).length <= 0 ? (
				<>
					<small className="fst-italic text-muted">&middot; Tidak Ada Perawat &middot;</small>
				</>
				): (
				<>
				<div className="mb-3 classborderbottom d-none">{JSON.stringify(uDatamainObj.perawat_arr||[])}</div>
				<small className="mx-1">&middot;</small>
				{(uDatamainObj.perawat_arr||[]).
					filter(vItems=>(vItems.status_hapus||"TIDAK")!=="YA").
					map((vItems,vKeys)=>{
					const  {
						id_perawat,nama_perawat,rate_bintang,catatan
					} = vItems;

					return (
					<small className="fst-italic d-inline-block" key={vKeys}>
						<span className="fst-italic">{nama_perawat||""}</span>
						<b style={{width:24,height:24}}
							className="position-relative ms-1  d-inline-block align-middle">
							<CIcon icon="cilBadge" className="position-absolute text-warning" 
								style={{
									top:"50%",left:"50%",
									transform: "translate(-50%, -50%)",
								}} 
								height={24}/>
							<small style={{
									top: "35%",
									left: "50%",
									transform: "translate(-50%, -50%)",
									fontSize:10,
								}}
								className="position-absolute text-danger">{rate_bintang}</small>
						</b>
						{(catatan||"").trim() !== "" && (
							<CIcon icon="cilNotes" className="text-success align-middle" height={24}/>
						)}
						<span className="mx-1">&middot;</span>
					</small>
					)
				})}
				</>
				)}

				<div className="my-2 classborderbottom"/>

				<CTooltip className="d-none d-lg-block" content="--Edit Perawat">
				<CLink onClick={()=>hdlKlikPerawat()} className="classcursorpointer">
					<CIcon icon="cilPencil" className="classikonbox" height={23}/>
				</CLink>
				</CTooltip>
			</>
			)}
			</CCardBody>
		</CCard>
		)//>
	}
	const contentSubjective = () => {
		if(uHtml500msg) return "";

		const vEditobj	= uDatamainObj.edit_obj || {};
		return(
		<CCard className="classbgcard h-100">
			<CCardHeader className="py-0 pt-1 classfontsmaller">
				<small>Subjective</small>
			</CCardHeader>
			
			<CCardBody>
				<div className="d-flex justify-content-between my-2">
					<div style={{maxWidth:"35%"}}><small>Anamnase</small></div>
					<div className="d-flex justify-content-end text-end">
						<div className="px-1">{uDatamainObj.anamnase || "-"}</div>

						<div className="">
						{(uDatamainObj.init_satusehat||"BELUM") === "SUDAH" ? (
							<CBadge color="light" className="border border-success" size="sm">
							<CIcon icon="cilCheck" className="text-success fw-bolder"/>
							</CBadge>
						) : (
						<>
						{(parseInt(uDatamainObj.anamnase_id)||0) > 0 && (
						<CLink onClick={()=>hdlKlikClearfield("anamnase_id")} className="d-none classcursorpointer">
						<CIcon icon="cilX" className="classikonbox mx-0 text-danger border-danger" height={15}/>
						</CLink>
						)}

						<CLink onClick={()=>hdlKlikAnamnase()} className="classcursorpointer">
						<CIcon icon="cilPencil" className="classikonbox" height={23}/>
						</CLink>
						</>
						)}
						</div>
					</div>
				</div>

				<div className="d-flex justify-content-between my-2">
					<div style={{maxWidth:"35%"}}><small>Keterangan<span className="ms-1 d-none d-lg-inline">Subjective</span></small></div>
					{vEditobj.nama_field === "anamnase_keterangan" ? (
					<div className="ps-2 text-end" style={{width:"65%"}}>
						{((vEditobj.is_processing||false)===true
						) ? (
						<CSpinner color="warning" size="sm"/>
						) : (
						<CInputGroup size="sm">
						<CFormInput size="sm"
							value={vEditobj.value||""}
							onChange={(e)=>setDatamainObj({...uDatamainObj,
								edit_obj: {...(uDatamainObj.edit_obj || {}),value: e.target.value }
							})}
							onKeyDown={(e)=>hdlKDownfieldedit(e)}
							id="inpeditfield"/>
						<CButton size="sm" color="secondary"
							onClick={()=>hdlKlikSimpanfield()}
							id="btneditfield">
							<CIcon icon="cilCheck"/>
						</CButton>
						</CInputGroup>
						)}
					</div>
					) : (
					<div className="d-flex justify-content-end">
						<div className="px-1">{uDatamainObj.anamnase_keterangan || "-"}</div>

						<CLink onClick={()=>hdlKlikEditfield("anamnase_keterangan")} className="classcursorpointer">
						<CIcon icon="cilPencil" className="classikonbox" height={23}/>
						</CLink>
					</div>
					)}
				</div>
			</CCardBody>
		</CCard>
		)//>
	}
	const contentObjective = () => {
		if(uHtml500msg) return "";

		const vEditobj	= uDatamainObj.edit_obj || {};
		return(
		<CCard className="classbgcard h-100">
			<CCardHeader className="py-0 pt-1 classfontsmaller">
				<small>Objective</small>
			</CCardHeader>
			
			<CCardBody>
				{vEditobj.nama_field === "objective_keterangan" ? (
				<div>
					{((vEditobj.is_processing||false)===true
					) ? (
						<center><CSpinner color="warning"/></center>
					) : (
					<>
					<CInputGroup size="sm" className="align-items-start">
						<CFormTextarea size="sm" rows={3}
							value={UFunc.br2nl(vEditobj.value||"")}
							onChange={(e)=>setDatamainObj({...uDatamainObj,
								edit_obj: {...(uDatamainObj.edit_obj || {}),value: UFunc.nl2br(e.target.value) }
							})}
							onKeyDown={(e)=>hdlKDownfieldedit(e)}
							id="inpeditfield"/>
						<CButton size="sm" color="secondary"
							onClick={()=>hdlKlikSimpanfield()}
							id="btneditfield">
							<CIcon icon="cilCheck"/>
						</CButton>
					</CInputGroup>
					<div className="classpetunjuk">*) {uBahasaObj.petunjuk_textarea || "petunjuk_textarea"}</div>
					</>
					)}
				</div>
				) : (
				<div className="d-flex justify-content-between">
					<div className="pe-2">{(uDatamainObj.objective_keterangan||"")==="" 
						? (<small className="text-muted fst-italic">&middot; Tidak Ada Keterangan &middot;</small>) 
						: (<>{UFunc.renderHTML(uDatamainObj.objective_keterangan)}</>)}
					</div>
						
					<CLink onClick={()=>hdlKlikEditfield("objective_keterangan")} className="classcursorpointer">
						<CIcon icon="cilPencil" className="classikonbox" height={23}/>
					</CLink>
				</div>
				)}
			</CCardBody>
		</CCard>
		)//>
	}
	const contentItem = () => {
		if(uHtml500msg) return "";

		if((uDatamainObj.items_arr || []).length <= 0) return (
			<CCard className="classbgcard mb-2">
				<CCardHeader>Assesment & PLAN</CCardHeader>

				<CCardBody>
				<small className="text-muted fst-italic">&middot; Data Tidak Ditemukan &middot;</small>
				</CCardBody>
			</CCard>
		)//>

		const vEditobj	= uDatamainObj.edit_obj || {};
		return (uDatamainObj.items_arr || []).map((vItems,vKeys)=>{
			const {
				poin_perawat,init_garansi,tgl_batas_garansi,no_cicilan,qty,
				diagnosa_id,diagnosa,diagnosa_ket,tindakan,ket_gigi,diskon_terapi,
				terapi_biaya,terapi_caption,terapi_sub_id,id_item
			} = vItems;

			return (
			<CCard className="classbgcard mb-1" key={vKeys}>
				<CCardHeader className="d-flex">
					<div className="text-end px-1" style={{width:25}}>{vKeys+1}.</div>
					
					<div className="px-1">
						<b>{terapi_caption||"terapi_caption"}</b>
						<span className="mx-2">&middot;</span>
						{((parseInt(qty)||0) > 1 || (parseFloat(diskon_terapi)||0) > 0) && (
						<>
							<small className="">
							<b className="text-primary">{UFunc.formatAngka(qty)}</b> Unt
							
							<span className="mx-2">x</span>

							{(parseFloat(diskon_terapi)||0) > 0 ? (
							<>
								(
								<span className="">{UFunc.formatAngka(terapi_biaya)}</span>
								<span className="text-danger">-{UFunc.formatAngka(diskon_terapi)}</span>
								)
							</>
							) : (
								<span className="">{UFunc.formatAngka(terapi_biaya)}</span>
							)}
							</small>

							<span className="mx-2">&middot;</span>
						</>
						)}
						<b className="text-success">Rp{UFunc.formatAngka(
							(parseInt(qty)||1) * (
								(parseFloat(terapi_biaya)||0) - (parseFloat(diskon_terapi)||0)
							))}</b>
					</div>
				</CCardHeader>

				<CCardBody>
				<CRow>
					<CCol lg="6">
					<div className="d-flex justify-content-between my-2">
						<div style={{maxWidth:"35%"}}><small>Nomor Gigi</small></div>
						<div className="d-flex justify-content-end">
						{(vEditobj.nama_field === "items"
							&& vEditobj.items_idx === vKeys
							&& vEditobj.items_var === "ket_gigi"
							&& (vEditobj.is_processing||false) === true
						) ? (
							<CSpinner color="warning" size="sm"/>
						) : (
						<>
							<div className="px-1 text-info">{ket_gigi || "-"}</div>

							<div className="text-end" style={{minWidth:(uISCellphoneview ? 52 : 0)}}>
							{(ket_gigi||"").trim() !== "" && (
							<CLink onClick={()=>hdlKlikClearfield("items",{idxkey:vKeys,nama_vars:"ket_gigi"})} className="classcursorpointer">
								<CIcon icon="cilX" className="classikonbox mx-0 border-danger text-danger" height={15}/>
							</CLink>
							)}

							<CLink onClick={()=>hdlKlikPilihgigi(vKeys)} className="classcursorpointer">
								<CIcon icon="cilPencil" className="classikonbox" height={23}/>
							</CLink>
							</div>
						</>
						)}
						</div>
					</div>

					<div className="classborderbottom my-2"/>

					<div className="d-flex justify-content-between my-2">
						<div style={{maxWidth:"35%"}}><small>Assesment</small></div>
						<div className="d-flex justify-content-end text-end">
							<div className="px-1 text-primary">{diagnosa || "-"}</div>

							<div className="text-end" style={{minWidth:(uISCellphoneview ? 52 : 0)}}>
							{(uDatamainObj.init_satusehat||"BELUM") === "SUDAH" ? (
								<CBadge color="light" className="border border-success" size="sm">
								<CIcon icon="cilCheck" className="text-success fw-bolder"/>
								</CBadge>
							) : (
							<>
								{(parseInt(diagnosa_id)||0) > 0 && (
								<CLink onClick={()=>hdlKlikClearfield("items",{idxkey:vKeys,nama_vars:"diagnosa_id"})} className="classcursorpointer">
									<CIcon icon="cilX" className="classikonbox mx-0 border-danger text-danger" height={15}/>
								</CLink>
								)}

								<CLink onClick={()=>hdlKlikDiagnosa(vKeys)} className="classcursorpointer">
								<CIcon icon="cilPencil" className="classikonbox" height={23}/>
								</CLink>
							</>
							)}
							</div>
						</div>
					</div>

					<div className="d-flex justify-content-between my-2">
						<div style={{maxWidth:"35%"}}><small>Keterangan<span className="ms-1 d-none d-md-inline">Assesment</span></small></div>
						
						{(vEditobj.nama_field === "items"
							&& vEditobj.items_idx === vKeys
							&& vEditobj.items_var === "diagnosa_ket"
						) ? (
						<div className="text-end" style={{width: "65%"}}>
							{((vEditobj.is_processing||false)===true
							) ? (
								<CSpinner color="warning" size="sm"/>
							) : (
							<CInputGroup size="sm">
								<CFormInput size="sm"
									placeholder="--Isikan Keterangan Assesment"
									value={(vEditobj.value||"")}
									onChange={(e)=>setDatamainObj({...uDatamainObj,
										edit_obj: {...(uDatamainObj.edit_obj || {}),value: (e.target.value) }
									})}
									onKeyDown={(e)=>hdlKDownfieldedit(e)}
									id="inpeditfield"/>
								<CButton size="sm" color="secondary"
									onClick={()=>hdlKlikSimpanfield()}
									id="btneditfield">
									<CIcon icon="cilCheck"/>
								</CButton>
							</CInputGroup>
							)}
						</div>
						) : (
						<div className="d-flex justify-content-end text-end">
							<div className="px-1">{diagnosa_ket || "-"}</div>

							<CLink onClick={()=>hdlKlikEditfield("items",{idxkey:vKeys,nama_vars:"diagnosa_ket"})} className="classcursorpointer">
							<CIcon icon="cilPencil" className="classikonbox" height={23}/>
							</CLink>
						</div>
						)}
					</div>
					</CCol>

					<CCol>
					<div className="classborderbottom my-2 d-lg-none"/>

					<div className="d-block d-md-flex d-lg-block justify-content-between my-2">
						<div className="d-none d-md-block d-lg-none" style={{maxWidth:"35%"}}><small>PLANNING</small></div>
					
						{(vEditobj.nama_field === "items"
							&& vEditobj.items_idx === vKeys
							&& vEditobj.items_var === "tindakan"
						) ? (
						<div className="" style={{width: (uISTabletview ? "65%" : "auto")}}>
							{((vEditobj.is_processing||false)===true
							) ? (
								<center><CSpinner color="warning"/></center>
							) : (
							<>
							<CInputGroup size="sm" className="align-items-start">
								<CFormTextarea size="sm" rows={3}
									placeholder="--Isikan Keterangan Planning"
									value={UFunc.br2nl(vEditobj.value||"")}
									onChange={(e)=>setDatamainObj({...uDatamainObj,
										edit_obj: {...(uDatamainObj.edit_obj || {}),value: UFunc.nl2br(e.target.value) }
									})}
									onKeyDown={(e)=>hdlKDownfieldedit(e)}
									id="inpeditfield"/>
								<CButton size="sm" color="secondary"
									onClick={()=>hdlKlikSimpanfield()}
									id="btneditfield">
									<CIcon icon="cilCheck"/>
								</CButton>
							</CInputGroup>
							<div className="classpetunjuk">*) {uBahasaObj.petunjuk_textarea || "petunjuk_textarea"}</div>
							</>
							)}
						</div>
						) : (
						<div className="d-flex justify-content-between">
							<div className="pe-2">
								{(tindakan||"").trim() ==="" ? (
									<small className="text-muted fst-italic">&middot; Tidak Ada Keterangan PLANNING &middot;</small>
								) : (
									<i style={{color:"maroon"}}>{UFunc.renderHTML(tindakan)}</i>
								)}
							</div>
								
							<CLink onClick={()=>hdlKlikEditfield("items",{idxkey:vKeys,nama_vars:"tindakan"})} className="classcursorpointer">
								<CIcon icon="cilPencil" className="classikonbox" height={23}/>
							</CLink>
						</div>
						)}
					</div>
					</CCol>
				</CRow>
				</CCardBody>
			</CCard>
			)
		})//>
	}
	const contentDlgform = () => {}
	//---END CONTENT--/

	//---REST_API--/
	const apiLoaddata = async() => {
		const vHeaderObj= {
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
		}
		const vFetchdataArr	= [
			{
				name:"Main",
				urls: pjson.homepage+"api/api_rekammedis/ld_main",
				headers: {...vHeaderObj,body:JSON.stringify({ send_rekammedisid: uRekammedisID, send_cabangid:uTokenObj.user_cabangid, send_tokenauth: uTokenObj.userinit })}
			},
			{
				name:"Item",
				urls: pjson.homepage+"api/api_rekammedis/ld_item",
				headers: {...vHeaderObj,body:JSON.stringify({ send_rekammedisid: uRekammedisID, send_cabangid:uTokenObj.user_cabangid, send_tokenauth: uTokenObj.userinit })}
			},
			{
				name:"Perawat",
				urls: pjson.homepage+"api/api_rekammedis/ld_perawat",
				headers: {...vHeaderObj,body:JSON.stringify({ send_rekammedisid: uRekammedisID, send_cabangid:uTokenObj.user_cabangid, send_loadmaster:"YA",send_tokenauth: uTokenObj.userinit })}
			},
			{
				name:"Master Data",
				urls: pjson.homepage+"api/api_rekammedis/ld_master",
				headers: {...vHeaderObj,body:JSON.stringify({send_tokenauth: uTokenObj.userinit })}
			},
		];

		const vFetchprosesArr = vFetchdataArr.map(vItems => {
			return fetch((vItems.urls||""),(vItems.headers||{})).
				then(response=>{
					if (!response.ok) {
						throw new Error(`Failed to fetch item ${vItems.name}: ${response.status}`);
					}
					setSessionaktif(false);
					return response.json();
				});
		});

		setHtml500msg();
		setDatamainObj({})

		setLoading(true);
		setLoadingview(true);
		try {
			const vFetchresultArr = await Promise.all(vFetchprosesArr);

			setSessionaktif(true);
			let vTmpmainObj = {}
			vFetchresultArr.forEach((vItems,vKeys) => {
				const vVarproses = ((vFetchdataArr[vKeys] || {}).name||"").toUpperCase();

				//console.log("(Rekammedisform - apiLoaddata) vItems "+vVarproses,JSON.stringify(vItems));
				if(vItems.info) {
					setHtml500msg("["+vVarproses+"] "+vItems.info); return;
				} else if(vItems.errors) {
					console.log("(Rekammedisform - apiLoaddata) vItems.errors : "+vItems.errors);
					const vMsg = (pjson.mydefault.environment==="development")
						? vItems.errors : pjson.mydefault.msgFetchError;
					setHtml500msg("<div class='text-danger'>"+"["+vVarproses+"] "+vMsg+"</div>");
					return;
				} else if(vItems.expired) {
					setLoading(true); prosesExpired(); return;
				}

				if(!vItems.tampil) return;

				if(vVarproses === ("Main").toUpperCase()) {
					vTmpmainObj = {...vTmpmainObj,
						...(JSON.parse(vItems.datamain || "{}")),
					}
				} else if(vVarproses === ("Item").toUpperCase()) {
					vTmpmainObj = {...vTmpmainObj,
						items_arr: JSON.parse(vItems.dataitem || "[]"),
					}
				} else if(vVarproses === ("Perawat").toUpperCase()) {
					vTmpmainObj = {...vTmpmainObj,
						perawat_arr: JSON.parse(vItems.dataperawat || "[]"),
					}
				} else if(vVarproses === ("Master Data").toUpperCase()) {
					setDataanamnaseArr(JSON.parse(vItems.dataanamnase||"[]"));
					setDatadiagnosaArr(JSON.parse(vItems.datadiagnosa||"[]"));
				}
			});

			setDatamainObj(vTmpmainObj);
		} catch(error) {
			console.log("(Rekammedisform - apiLoaddata) catch-error : "+error.message);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		} finally {
			setLoadingview(false);
			setLoading(false);
		}
	}
	const apiProsessimpanfield = () => {
		setDatamainObj({...uDatamainObj,
			edit_obj: {...(uDatamainObj.edit_obj||{}),
				is_processing: true,
			}
		});
		if(uDatamainObj.edit_obj.jenis_field === "lookup") setLoading(true);

		/*let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
			setDatamainObj({...uDatamainObj,edit_obj:undefined});
			setDlglookupshow(false);
		},2500);return;//-*/

		const vDATAS	= JSON.stringify({
			send_editvars : JSON.stringify({
				...(uDatamainObj.edit_obj||{}),
				is_processing: undefined,
			}),
			send_rekammedisid: uRekammedisID,
			send_cabangid: uTokenObj.user_cabangid,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_rekammedis/pr_editfield";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			//console.log("(Rekammedisform - apiProsessimpanfield) edit_obj ",uDatamainObj.edit_obj);
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
				let vChangedObj	= { edit_obj:undefined };
				if(uDatamainObj.edit_obj.nama_field === "perawat_arr") {
					const vPerawatnewArr = JSON.parse(output_string.perawatnew || "[]");
					vChangedObj = {...vChangedObj,
						perawat_arr: vPerawatnewArr
					}
				}else if(uDatamainObj.edit_obj.nama_field === "anamnase_id") {
					const vArridx = UFunc.getObjectIndeks(uDataanamnaseArr,uDatamainObj.edit_obj.value);
					vChangedObj = {...vChangedObj,
						anamnase_id: parseInt(uDatamainObj.edit_obj.value)||0,
						anamnase: (uDataanamnaseArr[vArridx]||{}).nama_anamnase,
					}
				}else if(uDatamainObj.edit_obj.nama_field === "anamnase_keterangan") {
					vChangedObj = {...vChangedObj,
						anamnase_keterangan: uDatamainObj.edit_obj.value || ""
					}
				}else if(uDatamainObj.edit_obj.nama_field === "objective_keterangan") {
					vChangedObj = {...vChangedObj,
						objective_keterangan: uDatamainObj.edit_obj.value || ""
					}
				}else if(uDatamainObj.edit_obj.nama_field === "items") {
					const vArridx 	= uDatamainObj.edit_obj.items_idx;
					const vItemsArr	= (uDatamainObj.items_arr || []); 

					if(uDatamainObj.edit_obj.items_var === "ket_gigi") {
						const vOdontogramnewArr = JSON.parse(output_string.odontogramarr_str || "[]");
						const vKetgigi 	= vOdontogramnewArr.map(vItems=>{
							return (vItems.nomor_gigi==="ALL"? "SEMUA GIGI" : "No-"+vItems.nomor_gigi);
						}).join(", ");

						vItemsArr[vArridx]	= {...(vItemsArr[vArridx]||{}),
							ket_gigi: vKetgigi,
							odontogram_arr: vOdontogramnewArr,
						}
					} else if(uDatamainObj.edit_obj.items_var === "diagnosa_id") {
						const vDiagnosaidx = UFunc.getObjectIndeks(uDatadiagnosaArr,uDatamainObj.edit_obj.value);
						vItemsArr[vArridx]	= {...(vItemsArr[vArridx]||{}),
							diagnosa_id: parseInt(uDatamainObj.edit_obj.value)||0,
							diagnosa: (uDatadiagnosaArr[vDiagnosaidx]||{}).nama_diagnosa,
						}
					} else if(uDatamainObj.edit_obj.items_var === "diagnosa_ket") {
						vItemsArr[vArridx]	= {...(vItemsArr[vArridx]||{}),
							diagnosa_ket: uDatamainObj.edit_obj.value || "",
						}
					} else if(uDatamainObj.edit_obj.items_var === "tindakan") {
						vItemsArr[vArridx]	= {...(vItemsArr[vArridx]||{}),
							tindakan: uDatamainObj.edit_obj.value || "",
						}
					}

					vChangedObj = {...vChangedObj,
						items_arr: vItemsArr,
					}
				}

				setDatamainObj({...uDatamainObj,...vChangedObj});
				setDlglookupshow(false);
			} else {
				setDatamainObj({...uDatamainObj,
					edit_obj: {...(uDatamainObj.edit_obj||{}),
						is_processing: undefined,
					}
				});
				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Periksa - apiSimpanmain) output_string.errors : "+output_string.errors);
					const vMsg = (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				} else if(output_string.expired) {
					setLoading(true); prosesExpired(); return;
				}
			}
		})
		.catch((error) =>{
			setDatamainObj({...uDatamainObj,
				edit_obj: {...(uDatamainObj.edit_obj||{}),
					is_processing: undefined,
				}
			});
			setLoading(false);
			console.log("(Rekammedis - apiSimpanmain) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR")
		});
	}
	const apiKirimsatusehat = () => {
		const vTabelID 			= parseInt(uDatamainObj.id_progress)||0; if(vTabelID <= 0) return;
		const vAccesstoken 		= uTokensatusehatObj.access_token;
		
 		if(!vAccesstoken) {
 			loadToken(apiKirimsatusehat); return;
 		}
		const vLimitedsec		= parseInt(uTokensatusehatObj.expires_in || "0");
		const vTimestampnow 	= new Date();
		const vTimetoken		= new Date(parseInt(uTokensatusehatObj.issued_at || "0"));
		const vSelisih			= UFunc.Datetimeselisih(vTimetoken,vTimestampnow).dtk;

		if(vSelisih > vLimitedsec) {
 			loadToken(apiKirimsatusehat); return;
		}

		setLoading(true);

		/*let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);

			initFormawal();
			showToast(uBahasaObj.pesan_sukses,"SUKSES")
		},2000); return;//--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : vTabelID,
			send_accesstoken : vAccesstoken,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_statuspasien/pr_kirimsatusehat";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
				const vIHSmessage 	= output_string.ihs_message || "";

				setDatamainObj({...uDatamainObj,init_satusehat:"SUDAH"});
				if(vIHSmessage !== "")
					showToast("SATUSEHAT: <b>"+vIHSmessage+"</b>","SUKSES");
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Rekammedisform - apiProsessatusehat) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Rekammedisform - apiProsessatusehat) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{
		document.addEventListener("keydown",hdlKDownDocument);

		return ()=>{
			document.removeEventListener("keydown",hdlKDownDocument);
		}
	})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
    	
    	apiLoaddata();

    	return () => {
    		setDatamainObj({});
			setLoadingview(false);setDlglookupshow(false);setDlgperawatshow(false);
			setDlgodontogramshow(false);
			setDatadiagnosaArr([]);setDataanamnaseArr([]);
    	}
	},[])
	React.useEffect(()=>{
		if(!uISDlglookupshow) {
			setDlglookupdataObj({});

			if(uDatamainObj.edit_obj === "anamnase_id"
				) setDatamainObj({...uDatamainObj,edit_obj:undefined});
			return;
		}
		//console.log("(Rekammedisform - [uISDlglookupshow]) uDlglookupdataObj.data_arr",uDlglookupdataObj.data_arr)
	},[uISDlglookupshow])
	React.useEffect(()=>{
		if(!uISDlgperawatshow) { 
			setDlglookupdataObj({}); 
			setDatamainObj({...uDatamainObj,edit_obj:undefined});
			uDispatch({type: "set", perawat_selecting_str: undefined});
			return 
		}
	},[uISDlgperawatshow])
	React.useEffect(()=>{
		if(!uISDlgodontogramshow) { 
			setDlgodontogramdataObj({}); 
			setDatamainObj({...uDatamainObj,edit_obj:undefined});
			uDispatch({type: "set", gigi_processing_str: undefined});
			return; 
		}
	},[uISDlgodontogramshow])
	React.useEffect(()=>{
		if(!uISExecutesimpanfield) return;
		setExecutesimpanfield(false);

		hdlKlikSimpanfield();
	},[uISExecutesimpanfield])

	//---END EFFECT--/

	//console.log("(Rekammedisform) uNavigate => "+JSON.stringify(uNavigate))
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-3 p-0">
		<CContainer fluid className="classheadertop" style={{minHeight:64}}>
			<CHeaderToggler className="px-0" onClick={() => hdlKlikBack() }>
			<CIcon icon="cilArrowCircleLeft" className="align-top me-2" height={30}/>
			</CHeaderToggler>
			
			<CHeaderBrand className="me-auto text-normal fw-normal">
				<small>
				<b>Edit RM{uDatamainObj.pasien_caption && (<>:<span className="ms-1 text-info">{uDatamainObj.pasien_caption}</span></>)}</b>
				</small>
			</CHeaderBrand>

			<CHeaderNav className="d-none d-md-block">{contentHeadernav()}</CHeaderNav>
		</CContainer>

		<CContainer fluid className="bg-white p-2 px-3 justify-content-center align-items-center d-md-none" 
			style={{minHeight:52}}>
			{contentHeadernav()}
		</CContainer>
		</CHeader>

		<div className="body flex-grow-1 px-2 px-lg-5 mb-3">
		<CContainer xxl className="px-0">
		{(uLoadingview) ? (
			<CCard>
			<CCardBody className="text-center py-3 py-lg-5">
				<i className="classblinking text-primary">Please Wait..</i>
			</CCardBody>
			</CCard>
		) : (
		<>
			{(uHtml500msg) ? (
			<CCard className="classbgcard mb-2">
				<CCardHeader>Error Page 500</CCardHeader>
				<CCardBody>
					<div className="mx-3">{UFunc.renderHTML(uHtml500msg)}</div>
				</CCardBody>
			</CCard>
			) : (
			<>
				<div className="d-none">{JSON.stringify(uDatamainObj)}</div>
				<CRow className="align-items-stretch">
				<CCol md="6" className="mb-3">{contentKunjungan()}</CCol>

				<CCol className="mb-3">{contentPerawat()}</CCol>
				</CRow>

				<CRow className="align-items-stretch">
				<CCol md="6" className="mb-3">{contentSubjective()}</CCol>

				<CCol className="mb-3">{contentObjective()}</CCol>
				</CRow>

				{contentItem()}
			</>
			)}
		</>
		)}
		</CContainer>
		</div>
		</div>

		<MyDialogform
			options={{centered:true,size:"lg"}}
			onSimpan={hdlKlikDlgformsimpan}
			show={uISDlgformshow} 
			dialogHeader={uDlgformObj.header}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>

		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupdataObj.dlg_header||"Lookup Data"}
			inputValue={uDlglookupdataObj.dlg_kwdinput||""}
			dataItemArr={uDlglookupdataObj.data_arr || []} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"
			{...props}/>

		<MyDialogperawat
			show={uISDlgperawatshow}
			toggle={()=>setDlgperawatshow(false)}
			dataSelectedArr={uDlgperawatdataObj.selected_arr||[]}
			onKlikSimpan={hdlKlikDlgperawatsimpan}
			id="iddialogperawat"
			{...props}/>

		<MyDialogodontogram
			show={uISDlgodontogramshow}
			toggle={()=>setDlgodontogramshow(false)}
			dataSelectedArr={uDlgodontogramdataObj.selected_arr||[]}
			onKlikSimpan={hdlKlikDlgodontogramsimpan}
			id="iddialogodontogram"
			{...props}/>
		</>
	)//>
}	

export default Rekammedisform